import React from 'react';
import { InsuranceCompanyBatch } from '../../../../Consts/InsuranceCompanyBatchesDefaultColumns.const';
import {
	DataTable,
	DataTableColumn,
} from '../../../../../Base/Components/DataTable/DataTable';

interface Props<TTable = null> {
	data: InsuranceCompanyBatch[];
	columns: DataTableColumn<InsuranceCompanyBatch, TTable>[];
	table?: TTable | null;
}

const ManagerInsuranceCompaniesBatchesTable = <TTable = null,>({
	data,
	columns,
	table = null as TTable,
}: Props<TTable>) => {
	return (
		<DataTable<InsuranceCompanyBatch, TTable>
			data={data}
			columns={columns}
			table={table as TTable}
		/>
	);
};

export default ManagerInsuranceCompaniesBatchesTable;
